import { CardOrderBase } from "./CardOrderBase";

export class CardOrderWorkshopCard extends CardOrderBase{
    KortBrugerEfternavn:string = "";
    KortBrugerFornavn:string = "";
    FoedselsDato:Date | null = null;
    KortEjerNavn:string = "";
    KortEjerAdresse:string = "";
    MekanikerAdresse:string = "";
    MekanikerPostNr:string = "";
    MekanikerBy:string = "";
    PostAdresseNavn:string = "";
    PostAdresseVejOgNr:string = "";
    PostAdresseStedNavn:string = "";
    PostAdressePostNr:string = "";
    PostAdressePostDistrikt:string = "";
    GyldighedStartDato:Date  | null = null;
    KortNrTidligereKort:string = "";
    UdloebsDato:Date | null = null;
    UdstedendeMyndighed:string = "";
    PersonNr:string = "";
    CvrNr:string = "";
    KoereKortNationalitet:string = "";
    KoerekortUdstedendeMyndighed:string = "";
    AutorisationsNr:string = "";
    AnsvarligIndehaver:string = "";
    Antal:string = "";
    Malfunctioning:boolean = false;
    IsAndenGeneration:string = "";

    //These values are always null, based on looking at older orders.
    StamkortReferenceNr:string|null = null;
    MekanikerCoNavn:string|null = null;
}
